import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const iconButtonSize = '28px';
export const useStyles = makeStyles()((theme) => ({
    floatingFavoritesButtonContainer: {
        position: 'fixed',
        right: 0,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        border: `1px solid ${colors.grey.grey7}`,
        borderRight: 'none',
        borderTopLeftRadius: spacing.xxs,
        borderBottomLeftRadius: spacing.xxs,
        boxShadow: '0 2px 8px #0000001f',
        padding: '19px 21px 3px 8px',
        cursor: 'pointer',
    },
    floatingFavoritesBadge: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        '& .MuiBadge-badge': Object.assign(Object.assign({}, theme.typography.xxs_bold), { width: spacing.medium, height: spacing.medium, padding: '0px 3px', borderRadius: '50%', top: '-4px', backgroundColor: colors.primary.gold4 }),
    },
    floatingFavoritesIconButton: {
        color: colors.background.BLACK,
        width: iconButtonSize,
        height: iconButtonSize,
        padding: '2.33px',
    },
    slideIn: {
        transform: 'translateX(0%)',
        opacity: 1,
        transition: 'transform 1s cubic-bezier(0.22, 1, 0.36, 1), opacity 1s cubic-bezier(0.22, 1, 0.36, 1)',
    },
    slideOut: {
        transform: 'translateX(100%)',
        opacity: 0,
        transition: 'transform 2s cubic-bezier(0.22, 1, 0.36, 1), opacity 2s cubic-bezier(0.22, 1, 0.36, 1)',
    },
}));
